export default __webpack_public_path__ + "static/media/check-in.483b0b81.gif";